import React from "react";
import { Review } from "@/types";
import StarRating from "@/components/ui/StarRating";
import Card, { CardBody } from "@/components/ui/Card";
import { FaUser, FaQuoteLeft } from "react-icons/fa";
import { format } from "date-fns";
import { DATE_FORMAT } from "@/config/constants";

interface ReviewCardProps {
  review: Review;
  compact?: boolean;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review, compact = false }) => {
  return (
    <Card hover className="h-full">
      <CardBody className="flex flex-col h-full">
        {!compact && (
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center text-white">
              <FaUser className="text-xl" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white">{review.customerName}</h4>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {format(review.createdAt, DATE_FORMAT)}
              </p>
            </div>
          </div>
        )}

        <div className="mb-3">
          <StarRating rating={review.rating} readonly size={compact ? "sm" : "md"} />
        </div>

        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{review.title}</h3>

        <div className="flex-grow">
          <div className="relative">
            <FaQuoteLeft className="absolute -top-2 -left-2 text-primary-200 dark:text-primary-900 text-2xl opacity-50" />
            <p
              className="text-gray-700 dark:text-gray-300 pl-6"
              style={
                compact
                  ? {
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }
                  : undefined
              }
            >
              {review.content}
            </p>
          </div>
        </div>

        {compact && (
          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {review.customerName} • {format(review.createdAt, DATE_FORMAT)}
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ReviewCard;
